// imports
import LazyLoad from "vanilla-lazyload";

import './components/modals';
import './components/nav';



const body = document.querySelector('body');
var Flickity = require("flickity");
require("flickity-hash");
require("fizzy-ui-utils");

//lazy load options
const lazyLoadOptions = {};
const pageLazyLoad = new LazyLoad(lazyLoadOptions);
pageLazyLoad.update();

setTimeout(() => {
    const queries = window.searchAndFilter.frontend.queries.getAll();
  
    if (queries.length > 0) {
      const query = queries[0]; // Get the first (and only) query
      const queryId = query.getId();
      if (query.getAttribute('resultsDynamicUpdate') === 'yes') {
        query.on('get-results/finish', function (queryObject) {
          pageLazyLoad.update();
        });
      }
    }
  }, 500);


const menuToggle = document.querySelector("#menu-toggle");


let lastScrollTop = 0;

// Scroll direction detection
window.addEventListener(
  "scroll",
  function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    body.classList.toggle("scroll-down", scrollTop > lastScrollTop);
    body.classList.toggle("scroll-up", scrollTop <= lastScrollTop);
    lastScrollTop = Math.max(scrollTop, 0);
  },
  false
);

// Add 'scrolled' class to body when scrolled past 600px
function toggleScrolledClass() {
  body.classList.toggle("scrolled", window.scrollY > 10);
}

window.addEventListener("scroll", toggleScrolledClass);

// Menu toggling functions
function toggleMenu() {
  body.classList.contains("menu-open") ? closeMenu() : openMenu();
}

function openMenu() {
  // Stop Lenis when menu opens

  
  menuToggle.setAttribute("aria-expanded", "true");
  body.classList.add("menu-start");
  
  setTimeout(() => body.classList.add("menu-open"), 1);
  setTimeout(() => body.classList.add("menu-animate"), 50);
}

function closeMenu() {
  body.classList.remove("menu-start", "menu-animate");
  menuToggle.setAttribute("aria-expanded", "false");
  
  setTimeout(() => {
    body.classList.remove("menu-open");
    
    // Restart Lenis when menu closes

  }, 200);
}

// Event listeners
menuToggle?.addEventListener("click", toggleMenu);

//
/**
 * Dropdown Menu JavaScript
 * Handles hover and click events for WordPress navigation menus
 */
document.addEventListener('DOMContentLoaded', function() {
  // Initialize anchor links

  
  const menuItems = document.querySelectorAll('.menu-item.has-dropdown');
  
  menuItems.forEach(function(item) {
      const link = item.querySelector('a');
      const submenu = item.querySelector('.dropdown-menu');
      let hoverTimer;
      
      if (!submenu) return;
      
      // Mouse enter event
      item.addEventListener('mouseenter', function() {
          clearTimeout(hoverTimer);
          item.classList.add('dropdown-open');
          submenu.style.display = 'block';
          
          // Animate dropdown appearance
          submenu.style.opacity = '0';
          submenu.style.transform = 'translateY(-10px)';
          
          setTimeout(function() {
              submenu.style.opacity = '1';
              submenu.style.transform = 'translateY(0)';
          }, 10);
      });
      
      // Mouse leave event
      item.addEventListener('mouseleave', function() {
          hoverTimer = setTimeout(function() {
              item.classList.remove('dropdown-open');
              submenu.style.opacity = '0';
              submenu.style.transform = 'translateY(-10px)';
              
              setTimeout(function() {
                  submenu.style.display = 'none';
              }, 200);
          }, 100);
      });
      
      // Click event for mobile/touch devices
      link.addEventListener('click', function(e) {
          // Check if this is an anchor link first
          const href = link.getAttribute('href');
          
          // If it's an anchor link, let the anchor link handler deal with it
          if (href && href.startsWith('#')) {
              return; // Let the anchor link handler take over
          }
          
          // Only prevent default if submenu exists and is currently hidden
          if (submenu && !item.classList.contains('dropdown-open')) {
              e.preventDefault();
              
              // Close other open dropdowns
              menuItems.forEach(function(otherItem) {
                  if (otherItem !== item) {
                      otherItem.classList.remove('dropdown-open');
                      const otherSubmenu = otherItem.querySelector('.dropdown-menu');
                      if (otherSubmenu) {
                          otherSubmenu.style.display = 'none';
                      }
                  }
              });
              
              // Toggle current dropdown
              item.classList.toggle('dropdown-open');
              if (item.classList.contains('dropdown-open')) {
                  submenu.style.display = 'block';
                  submenu.style.opacity = '1';
                  submenu.style.transform = 'translateY(0)';
              } else {
                  submenu.style.display = 'none';
              }
          }
      });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
      if (!e.target.closest('.menu-item.has-dropdown')) {
          menuItems.forEach(function(item) {
              const submenu = item.querySelector('.dropdown-menu');
              item.classList.remove('dropdown-open');
              if (submenu) {
                  submenu.style.display = 'none';
              }
          });
      }
  });
  
  // Handle keyboard navigation
  document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
          // Close dropdowns
          menuItems.forEach(function(item) {
              const submenu = item.querySelector('.dropdown-menu');
              item.classList.remove('dropdown-open');
              if (submenu) {
                  submenu.style.display = 'none';
              }
          });
          
          // Also close main menu if open
          if (body.classList.contains("menu-open")) {
              closeMenu();
          }
      }
  });

  
  // Arrow key navigation within dropdowns
  menuItems.forEach(function(item) {
      const submenuLinks = item.querySelectorAll('.dropdown-menu a');
      
      submenuLinks.forEach(function(link, index) {
          link.addEventListener('keydown', function(e) {
              if (e.key === 'ArrowDown') {
                  e.preventDefault();
                  const nextLink = submenuLinks[index + 1];
                  if (nextLink) nextLink.focus();
              } else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  const prevLink = submenuLinks[index - 1];
                  if (prevLink) {
                      prevLink.focus();
                  } else {
                      item.querySelector('a').focus();
                  }
              }
          });
      });
  });
});




const switcher = document.getElementById("sffe-language-switcher");

// Check if the switcher is present in the DOM
if (switcher) {
  const menu = document.querySelector("#sffe-language-menu"); // Adjust the selector as necessary

  // Function to toggle the display of the language menu
  function toggleMenuDisplay(event) {
    menu.classList.toggle("hidden");
  }

  // Attach click event listener to the language switcher
  switcher.addEventListener("click", toggleMenuDisplay);

  // Close the menu when a link inside the menu is clicked
  menu.addEventListener("click", function (event) {
    if (event.target.tagName === "A") {
      menu.classList.add("hidden");
    }
  });

  // Close the menu when clicking outside of the menu
  document.addEventListener("click", function (event) {
    if (!switcher.contains(event.target)) {
      menu.classList.add("hidden");
    }
  });
}


var panelCarousels = document.querySelectorAll(".panel-carousel");
var panelCarousel = function () {
  panelCarousels.forEach((i) => {
    let flkty = new Flickity(i, {
      cellAlign: "left",
      contain: false,
      wrapAround: false,
      resize: true,
      draggable: true,
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      hash: true,
    });

    // var cellsButtonGroup = document.querySelector(".label-nav");
    // if (cellsButtonGroup) {
    //   var cellsButtons = utils.makeArray(cellsButtonGroup.children);
    //   cellsButtonGroup.addEventListener("click", function (event) {
    //     var index = cellsButtons.indexOf(event.target);
    //     flkty.select(index);
    //   });

    //   flkty.on("select", function () {
    //     var previousSelectedButton =
    //       cellsButtonGroup.querySelector(".is-selected");
    //     var selectedButton = cellsButtonGroup.children[flkty.selectedIndex];
    //     previousSelectedButton.classList.remove("is-selected");
    //     selectedButton.classList.add("is-selected");
    //   });
    // }
    // var nextButton = document.querySelector(".carousel-next");
    // if (nextButton) {
    //   document.querySelector(".carousel-next").addEventListener("click", () => {
    //     flkty.next();
    //   });
    // }
    setTimeout(function () {
      flkty.resize();
    }, 500);
  });
};
if (panelCarousels) {
  panelCarousel();
}

window.toggleDescription = function(link) {
  const container = link.closest('.description-content');
  if (!container) return;

  const preview = container.querySelector('.description-preview');
  const full = container.querySelector('.description-full');

  if (!preview || !full) return;

  const isHidden = full.style.display === 'none' || full.style.display === '';

  if (isHidden) {
      preview.style.display = 'none';
      full.style.display = 'inline';
      link.textContent = 'Read Less';
  } else {
      preview.style.display = 'inline';
      full.style.display = 'none';
      link.textContent = 'Read More';
  }
};


document.addEventListener("DOMContentLoaded", function() {
  console.log("DOM fully loaded");

  const params = new URLSearchParams(window.location.search);
  const category = params.get("_resource-category");
  console.log("URL param _resource-category:", category);

  if (category) {
    console.log("Waiting for Search & Filter Pro AJAX to finish...");


      console.log("sf:ajaxfinish event fired");

      const target = document.getElementById("all-resources");
      if (target) {
        console.log("#all-resources found — scrolling now");

        const headerOffset = 100; // adjust this for your sticky header
        const elementPosition = target.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      } else {
        console.log("#all-resources NOT found in DOM");
      }
 
  } else {
    console.log("No _resource-category param found in URL — doing nothing");
  }
});
